var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractRedlining(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7096_13767",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7096_13767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98684 13.3158H11.9342V11.8421H8.98684V13.3158ZM8.98684 10.3684H14.1447V8.89474H8.98684V10.3684ZM6.77632 7.42105H14.1447V5.94737H6.77632V7.42105ZM6.5 17C5.52982 17 4.70395 16.6592 4.02237 15.9776C3.34079 15.2961 3 14.4702 3 13.5C3 12.8 3.18114 12.1737 3.54342 11.6211C3.9057 11.0684 4.38158 10.6509 4.97105 10.3684H3.09211V8.89474H7.51316V13.3158H6.03947V11.5289C5.58509 11.6272 5.21053 11.8605 4.91579 12.2289C4.62105 12.5974 4.47368 13.0211 4.47368 13.5C4.47368 14.0649 4.67325 14.5439 5.07237 14.9368C5.47149 15.3298 5.94737 15.5263 6.5 15.5263V17ZM8.98684 16.2632V14.7895H15.6184V4.47368H5.30263V7.42105H3.82895V4.47368C3.82895 4.06842 3.97325 3.72149 4.26184 3.43289C4.55044 3.1443 4.89737 3 5.30263 3H15.6184C16.0237 3 16.3706 3.1443 16.6592 3.43289C16.9478 3.72149 17.0921 4.06842 17.0921 4.47368V14.7895C17.0921 15.1947 16.9478 15.5417 16.6592 15.8303C16.3706 16.1189 16.0237 16.2632 15.6184 16.2632H8.98684Z",
    fill: "#40444D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractRedlining);
export default __webpack_public_path__ + "static/media/contract_redlining.702cc08d4aca28bddbcb889836e708f7.svg";
export { ForwardRef as ReactComponent };